import { useSelector } from 'react-redux';
import { Stack, useTheme } from '@rossum/ui/material';
import { UseCanvasDimensions } from '../../features/annotation-view/document-canvas-svg/useCanvasDimensions';
import { useDocumentStore } from '../../features/annotation-view/document-store/DocumentStore';
import { firstPageTopSelector } from '../../features/annotation-view/document-store/documentStoreSelectors';
import { SearchPanel } from '../../features/annotation-view/document-topbar/SearchPanel';
import { DocumentTranslationPanel } from '../../features/annotation-view/document-translation/DocumentTranslationPanel';
import { useTranslationEnabled } from '../../features/annotation-view/document-translation/hooks/useTranslationEnabled';
import { State } from '../../types/state';

type DocumentOverlayPanelsProps = {
  dimensions: UseCanvasDimensions;
};

export const DocumentOverlayPanels = ({
  dimensions,
}: DocumentOverlayPanelsProps) => {
  const firstPageTop = useDocumentStore(firstPageTopSelector(dimensions));

  const { targetLanguage } = useDocumentStore(state => state.translationState);

  const showSearchPanel = useSelector(
    (state: State) => state.search.shouldShow
  );

  const isTranslationEnabled = useTranslationEnabled();

  const theme = useTheme();

  return (
    <Stack
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: t => t.zIndex.appBar,
        gap: 1,
        alignItems: 'center',
      }}
      style={{
        top: `max(${theme.spacing(1)}, calc(${firstPageTop}px - ${theme.spacing(2)}))`,
      }}
    >
      <DocumentTranslationPanel />
      <SearchPanel
        open={showSearchPanel}
        shouldSearchTranslations={isTranslationEnabled && !!targetLanguage}
      />
    </Stack>
  );
};
